import React from 'react';
import { ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface NegotiationHeaderProps {
  contractId: string;
  onBack?: () => void;
  canNegotiate: boolean;
  /** Rendered beside the status pill (e.g. buyer withdraw offer). */
  headerActions?: React.ReactNode;
}

export const NegotiationHeader: React.FC<NegotiationHeaderProps> = ({
  contractId,
  onBack,
  canNegotiate,
  headerActions,
}) => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center space-x-4">
          {onBack ? (
            <Button
              variant="ghost"
              size="sm"
              onClick={onBack}
              className="text-white hover:bg-blue-700"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back
            </Button>
          ) : null}
          <div>
            <h1 className="text-2xl font-bold">Contract Negotiation</h1>
            <p className="text-blue-100 text-sm">Contract ID: {contractId}</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-end gap-2 sm:gap-3 ml-auto">
          <div
            className={`px-3 py-1 rounded-full text-sm font-medium ${
              canNegotiate
                ? 'bg-green-100 text-green-800'
                : 'bg-gray-100 text-gray-800'
            }`}
          >
            {canNegotiate ? 'Negotiation Active' : 'Negotiation Closed'}
          </div>
          {headerActions}
        </div>
      </div>
    </div>
  );
};

export default NegotiationHeader;
